import React, { useEffect } from 'react'
import { ButtonType } from '../../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useAppDispatch } from '../../../../store'
import { grey } from '../../../../colors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { deleteTermsSectionApi } from '../../../../store/slices/termsSectionsSlice/api'
import { actionLoading } from '../../../../store/slices/termsSectionsSlice/selectors'
import { type ISection } from '../../../../models/TermsSection'
import { type ApiError } from '../../../../models/Common'
import { notification } from '../../../../components/Notifications'

interface DeleteSectionProps {
  selectedRow?: ISection | Record<string, any>
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
  isTaskRunning?: boolean
  onTaskBlock?: () => void
}

const DeleteSection: React.FC<DeleteSectionProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage, isTaskRunning, onTaskBlock }) => {
  const dispatch = useAppDispatch()
  const loading = actionLoading()
  const theme = useTheme()

  useEffect(() => {
    if (selectedRow != null && isTaskRunning) {
      onTaskBlock?.()
      handleCloseModal?.()
    }
  }, [selectedRow])

  const handleDelete = async (): Promise<void> => {
    try {
      await dispatch(deleteTermsSectionApi({ urlId: selectedRow?.sectionId })).unwrap()
      handleCloseModal?.()
    } catch (error) {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message)
        showErrorModal?.()
        return
      }
      notification(customError?.message ?? 'Internal server error', { variant: 'error' })
    }
  }
  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
      You will not be able to recover this Section. All references to it will be removed.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteSection
